import React, {
  useCallback, useContext, useState,
} from 'react';
import {
  Alert, AlertTitle, Button, Grid, Toolbar,
} from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faList, faCalculator,
} from '@fortawesome/free-solid-svg-icons';
import api from '../../../api/req';
import { AppContext } from '../../../providers/authProvider';
import Loader from '../../../components/MaterialUI/loader';
import { EditorControls } from '../../BaseEditor';
import { checkTask } from '../../../api/checktask';
import LandsTablePart from './tp/land';

const xmlUrl = '/api/service/taxcalculation/';

function LandTaxCalculaion() {
  const [loading, setLoading] = useState(false);
  const [tpData, setTpData] = useState([]);
  const [err, setErr] = useState(null);
  const [filter, setFilter] = useState({ months: 1 });
  const { auth, currentUser } = useContext(AppContext);

  const onDone = useCallback((result) => {
    setLoading(false);
    // if (resultType === 1) {
    const tp = result.result.map((el) => ({
      ...el,
      isCalculate: true,
    }));

    setTpData(tp);
    // }
  }, []);

  const getDataList = useCallback(() => tpData.reduce((res, el) => {
    if (el.isCalculate) res.push(el.land.id);
    return res;
  }, []), [tpData]);

  const getRusult = useCallback(
    (resultType) => {
      const req = async () => {
        const r = await api.post(xmlUrl, auth, {
          ...filter,
          data_list: getDataList(),
          result_type: resultType,
        });
        if (!r.ok) throw new Error(`${r.status} ${r.statusText}`);
        // eslint-disable-next-line camelcase
        const { task_id } = await r.json();
        // eslint-disable-next-line camelcase
        return task_id;
      };
      setLoading(true);
      setErr(null);
      req()
        .then((d) => checkTask(
          d,
          auth,
          (res) => {
            // eslint-disable-next-line no-unused-expressions
            res.result.errors ? setErr(res.result.errors[0]) : onDone(res.result, resultType);
            // eslint-disable-next-line no-unused-expressions
            res.status !== 'PENDING' && setLoading(false);
          },
          (e) => {
            setErr(e ? e.message : 'Скасовано');
            setLoading(false);
          },
        ))
        .catch((e) => {
          setErr(e.message);
          setLoading(false);
        });
    },
    [auth, filter, getDataList, onDone],
  );

  return (
    <>
      {loading && (
        <Loader text="Завантаження" />
      )}

      {err && (
        <Alert severity="error">
          <AlertTitle>:-(</AlertTitle>
          {err}
        </Alert>
      )}
      <Toolbar sx={{ gap: 1 }}>
        <Button
          variant="contained"
          startIcon={<FontAwesomeIcon icon={faList} />}
          color="success"
          onClick={() => {
            // setListId(true);
            getRusult(1);
          }}
        >
          Переглянути
        </Button>

        <Button
          variant="contained"
          startIcon={<FontAwesomeIcon icon={faCalculator} />}
          color="success"
          onClick={() => {
            getRusult(2);
          }}
        >
          Розрахувати
        </Button>
      </Toolbar>
      <Grid container spacing={2}>
        <Grid item sm={12}>
          {currentUser.is_superuser && (
            <EditorControls.ItemPicker
              label="Установа"
              backend="/api/catalog/orgs/"
              canErase
              value={filter.org}
              onChange={(e, v) => setFilter(
                {
                  ...filter,
                  org: v,
                  org_id: v.id,
                },
              )}
            />

          )}
        </Grid>
        <Grid item sm={12} sx={{ display: 'flex' }}>
          <Grid item sm={2}>
            <EditorControls.DateInput
              value={filter.date}
              label="Дата"
              onChange={(e, v) => setFilter(
                {
                  ...filter,
                  date: v,
                },
              )}
            />
          </Grid>
          <Grid item sm={2}>
            <EditorControls.NumerInput
              value={filter.months}
              precision={0}
              label="Кількість місяців для розрахунку"
              onChange={(e, v) => setFilter(
                {
                  ...filter,
                  months: v,
                },
              )}
            />
          </Grid>
        </Grid>

        <Grid item sm={6}>
          <EditorControls.ItemPicker
            value={filter.locality}
            label="Населений пункт"
            backend="/api/catalog/localities/"
            canErase
            onChange={(e, v) => setFilter(
              {
                ...filter,
                locality: v,
                locality_id: v.id,
              },
            )}
          />
        </Grid>
        <Grid item sm={6}>
          <EditorControls.ItemPicker
            value={filter.region}
            label="Регіональна ознака (старостинство)"
            backend="/api/catalog/regions/"
            canErase
            onChange={(e, v) => setFilter(
              {
                ...filter,
                region: v,
                region_id: v.id,
              },
            )}
          />
        </Grid>

        <Grid item sm={6}>
          <EditorControls.ItemPicker
            value={filter.payer}
            label="Платник"
            backend="/api/catalog/payers/"
            canErase
            onChange={(e, v) => setFilter(
              {
                ...filter,
                payer: v,
                payer_id: v.id,
              },
            )}
          />
        </Grid>
        <Grid item sm={6}>
          <EditorControls.ItemPicker
            value={filter.land}
            label="Земельна ділянка"
            backend="/api/catalog/lands/"
            canErase
            onChange={(e, v) => setFilter(
              {
                ...filter,
                land: v,
                land_id: v.id,
              },
            )}
          />
        </Grid>

      </Grid>
      <LandsTablePart
        data={tpData}
        // onChange={onChange}
        onChange={(e, newRecs) => setTpData(newRecs)}
      />
    </>
  );
}

export default LandTaxCalculaion;
